import { createClient } from '@supabase/supabase-js';
import { getSupabaseConfig } from './config';

// Get Supabase configuration from environment variables
const { url: supabaseUrl, anonKey: supabaseAnonKey } = getSupabaseConfig();

// Export the supabase client for use across the app
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Export a function to create a new client (useful for server-side or different contexts)
export function createSupabaseClient(url?: string, key?: string) {
  return createClient(
    url || supabaseUrl,
    key || supabaseAnonKey
  );
}
